const event = (str: string) => `Login. ${str}`

export const LOGIN_BUTTON_CLICK = event('Login clicked')
export const FORGOT_PASSWORD_LINK_CLICK = event('Forgot password clicked')
export const CREATE_ACCOUNT_LINK_CLICK = event('Create account clicked')
